import React, { useId } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'

const ConfirmActionDialog = ({
  open,
  title,
  description,
  confirmLabel,
  onCancel,
  onConfirm,
  destructive = true,
}) => {
  const id = useId()
  const titleId = `confirm-action-title-${id}`
  const descriptionId = `confirm-action-description-${id}`

  return (
    <Dialog open={open} onClose={onCancel} aria-labelledby={titleId} aria-describedby={descriptionId}>
      <DialogTitle id={titleId} sx={{ fontSize: '1.25rem', fontWeight: 700, padding: '1.5rem 1.5rem 0.5rem' }}>
        {title}
      </DialogTitle>
      <DialogContent sx={{ padding: '0.5rem 1.5rem 1.5rem' }}>
        <DialogContentText id={descriptionId}>{description}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ padding: '0 1.5rem 1.5rem' }}>
        <Button onClick={onCancel}>Cancel</Button>
        <Button color={destructive ? 'error' : 'primary'} onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmActionDialog
